<template>
  <div>
    <my-header></my-header>

    <div class="group-box">

      <b-breadcrumb>
        <b-breadcrumb-item :to="{name:'contest_info'}">Contest {{contestId}}</b-breadcrumb-item>
        <b-breadcrumb-item :to="{name:'contest_groups'}">Groups</b-breadcrumb-item>
      </b-breadcrumb>

      <template v-if="isLoadedNormal">

        <p class="mb-3">
          Contest type: {{contestTypeName}}
        </p>

        <h2>Group {{groupId}}</h2>
        <rating-concrete :info="info" />

      </template>

    </div>

  </div>
</template>

<script>
import { getContestTypeName } from '../model/contest.js';

import { HTTP } from '../http-common.js';

import notifier from '../notifier.js';

import MyHeader from './Header.vue';
import RatingConcrete from './contest/RatingConcrete.vue';

const LOAD_STATE_INIT          = 1;
const LOAD_STATE_LOADING       = 2;
const LOAD_STATE_LOADED_NORMAL = 3;
const LOAD_STATE_LOADED_ERROR  = 4;

export default {
  name: 'ContestGroup',

  components: {
    MyHeader,
    RatingConcrete,
  },

  props: {
    contestGroupId: {
      type: Object,
      required: true,
    }
  },

  data() {
    return {
      loadState: LOAD_STATE_INIT,

      info: null,
    };
  },

  computed: {
    /** @returns {number} */
    contestId() {
      return this.contestGroupId.contestId;
    },

    /** @returns {number} */
    groupId() {
      return this.contestGroupId.groupId;
    },

    /** @returns {boolean} */
    isLoading() {
      return this.loadState === LOAD_STATE_LOADING;
    },

    /** @returns {boolean} */
    isLoadedNormal() {
      return this.loadState === LOAD_STATE_LOADED_NORMAL;
    },

    /** @returns {number} */
    contestType() {
      return this.info.contestType;
    },

    /** @returns {string} */
    contestTypeName() {
      return getContestTypeName(this.contestType);
    },
  },

  created() {
    this.loadPage();
  },

  methods: {
    loadPage() {
      notifier.deleteSenderNotifications(this);

      this.loadState = LOAD_STATE_LOADING;

      const url = `/contest/${this.contestId}/group/${this.groupId}`;
      HTTP.get(url)
      .then(response => {
        this.info = response.data.data;
        this.loadState = LOAD_STATE_LOADED_NORMAL;
      })
      .catch(err => {
        this.loadState = LOAD_STATE_LOADED_ERROR;
        notifier.showError(err, {sender: this});
      });
    },
  },

};
</script>

<style scoped>
.group-box {
  margin-left: 1rem;
  max-width: 600px;
}
</style>
